import React from 'react';
import PropTypes from 'prop-types';

import { routeNaming, goToPage } from '../../routes';
import { ParamsHelper } from '../../helpers/ParamsHelper';
import { HomeNavbar } from '../../common/home-navbar';
import { Footer } from '../../common/footer';
import { MainBody } from './main-body';
import { CompareSection } from '../../common/compare-section/CompareSection';
import styles from './ProductIndex.css';

const IPropTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      subMenuId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

/*
  Query parameters for this page:
    - pt: product type id (optional). This parameter indicates the product id
          of the products shown.
*/

const updateProductTypeParam = subMenuId => (productTypeId) => {
  const params = {};
  if (productTypeId !== null) {
    params.pt = productTypeId;
  }
  goToPage(routeNaming.PRODUCT_INDEX, { subMenuId }, params);
};

const ProductIndex = (props) => {
  const { match: { params: { subMenuId } } } = props;
  const productTypeId = ParamsHelper.parseQueryParams(props.location.search).pt;
  return (
    <div className={styles.container}>
      <HomeNavbar />
      <CompareSection />
      <MainBody
        productTypeId={productTypeId}
        subMenuId={subMenuId}
        onProductTypeUpdate={updateProductTypeParam(subMenuId)}
      />
      <Footer />
    </div>
  );
};

ProductIndex.propTypes = IPropTypes;

export { ProductIndex };



// WEBPACK FOOTER //
// ./src/pages/product-index/ProductIndex.jsx